import { HttpRequest } from '@angular/common/http';
import { JwtAccessTokenPaylaod } from './jwt-token.model';

const addJwtAuthorizationHeader = (
  request: HttpRequest<unknown>,
  jwtToken: string | null | undefined
): HttpRequest<unknown> => {
  if (jwtToken) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
  }

  return request;
};

const extractAccessTokenPayload = (jwtToken: string | null | undefined): JwtAccessTokenPaylaod => {
  if (jwtToken) {
    const parts = jwtToken.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }

    const payload = JSON.parse(atob(parts[1]));

    return {
      authorities: payload.authorities.split(','),
      availableOffers: payload.availableOffers,
      availableHeadquarters: payload.availableHeadquarters,
      superAdmin: payload.superAdmin,
      userId: payload.userId,
      accountId: payload.accountId,
      sub: payload.sub,
      iat: payload.iat,
      exp: payload.exp,
    };
  } else {
    throw new Error('Jwt Token is null or undefined');
  }
};

export const JwtTokenUtils = {
  addJwtAuthorizationHeader,
  extractAccessTokenPayload,
};
